const initialState = {
   open: false,
   mensaje: ''
};

const sliceConfig = {
   name: 'loading',
   initialState: initialState,
   reducers: {
      set(state, action) {
         if (typeof action.payload === 'boolean') {
            state.open = action.payload;
         } else {
            state.open = action.payload !== '';
            state.mensaje = action.payload;
         }
      },
      open(state) {
         state.open = true;
      },
      close(state) {
         state.open = false;
         state.mensaje = '';
      }
   }
};

export default sliceConfig;
